export default __webpack_public_path__ + "static/media/caramalogo-footer.ca4c2aa7.png";